'use strict';

import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import AuthTypes from '../constants/AuthTypes';
import normalizeError from '../utils/normalizeError';
import OverlayStore from '../stores/OverlayStore';
import ModalTypes from '../constants/ModalTypes';
import NotificationMessages from '../constants/NotificationMessages';
import InvitationActionCreators from '../actions/InvitationActionCreators';
import NotificationActionCreators from '../actions/NotificationActionCreators';

const ExternalActionCreators = {
  /**
   * An event will be triggered by auth_popup.html like this:
   * window.opener.require('ExternalActionCreators').handleAuthService({{ error | tojson | safe }}, {{ account | tojson | safe }}, '{{ service_type }}');
   */
  handleAuthService(err, response, serviceType, authType, next) {
    let actionType;

    switch (authType) {
    case AuthTypes.CONNECT:
      actionType = err ? ActionTypes.CONNECT_SERVICE_ACCOUNT_ERROR : ActionTypes.CONNECT_SERVICE_ACCOUNT_SUCCESS;
      break;
    case AuthTypes.LOGIN:
      actionType = err ? ActionTypes.LOGIN_WITH_SERVICE_ACCOUNT_ERROR : ActionTypes.LOGIN_WITH_SERVICE_ACCOUNT_SUCCESS;
      break;
    case AuthTypes.SIGNUP:
      actionType = err ? ActionTypes.SIGNUP_WITH_SERVICE_ACCOUNT_ERROR : ActionTypes.SIGNUP_WITH_SERVICE_ACCOUNT_SUCCESS;
      break;
    }

    AppDispatcher.handleServerFormAction({
      type: actionType,
      serviceType: serviceType,
      response: response,
      err: err ? normalizeError(err) : null
    });

    if (err) {
      console.log(err);
    } else {
      if (authType === AuthTypes.CONNECT) {
        NotificationActionCreators.showNotification(NotificationMessages.ACCOUNT_CONNECTED);
      }

      if (authType === AuthTypes.CONNECT && OverlayStore.hasModal(ModalTypes.SEND_INVITE)) {
        InvitationActionCreators.requestSocialFriendsPage(serviceType);
      } else if (next) {
        window.location = next;
      }
    }
  },

  handleFormResponse(err, response) {
    AppDispatcher.handleServerFormAction({
      type: err ? ActionTypes.LOGIN_WITH_EMAIL_SUCCESS : ActionTypes.LOGIN_WITH_EMAIL_ERROR,
      response: response,
      err: err ? normalizeError(err) : null
    });

    if (err) {
      console.log(err);
    } else {
      window.location.href = response && response.next || '/';
    }
  }
};

export default ExternalActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/ExternalActionCreators.js
 **/